export const APP = {
  // API_HOST: 'https://budget-api.mollerus.net',
  HOSTS: {
    API: 'https://budget-api.mollerus.net',
  },
  ROUTES: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    CALLBACK: '/implicit/callback',
    LEDGER: '/year',
  }
};
